var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { default as UiInput } from "@atlaskit/textfield";
import Field from "../../templates/Field";
import Icon from "../Icon";
import styled from "styled-components";
export default React.forwardRef(function (props, ref) {
    var label = props.label, error = props.error, before = props.before, after = props.after, isClearable = props.isClearable, rest = __rest(props, ["label", "error", "before", "after", "isClearable"]);
    var onChange = function (e) {
        var eventWithFallBack = __assign(__assign({}, e), { currentTarget: __assign(__assign({}, e.currentTarget), { value: e.currentTarget.value || "" }) });
        props.onChange && props.onChange(eventWithFallBack);
    };
    var onKeyDown = function (e) {
        props.onKeyDown && props.onKeyDown(e);
    };
    var onBlur = function (e) {
        var eventWithFallBack = __assign(__assign({}, e), { target: __assign(__assign({}, e.target), { value: e.target.value || "" }) });
        props.onBlur && props.onBlur(eventWithFallBack);
    };
    var onClear = function (e) {
        onChange(__assign(__assign({}, e), { currentTarget: __assign(__assign({}, e.currentTarget), { value: e.currentTarget.value || "" }) }));
    };
    var componentProps = __assign(__assign({}, rest), { elemAfterInput: after, elemBeforeInput: before });
    if (isClearable && props.value) {
        componentProps.elemAfterInput = (_jsxs(_Fragment, { children: [_jsx(StyledClearIcon, __assign({ onClick: onClear }, { children: _jsx(Icon.IonIcons5.IoClose, { size: 20 }) })), componentProps.elemAfterInput] }));
    }
    return (_jsx(Field, __assign({ label: label, error: error }, { children: _jsx(UiInput, __assign({ ref: ref }, componentProps, { value: props.value, onKeyDown: onKeyDown, onChange: onChange, onBlur: onBlur })) })));
});
var StyledClearIcon = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 0;\n  cursor: pointer;\n  margin-right: ", "px;\n"], ["\n  line-height: 0;\n  cursor: pointer;\n  margin-right: ", "px;\n"])), function (props) { return props.theme.spacing; });
var templateObject_1;
//# sourceMappingURL=index.js.map